import Auth from "./Auth";
import Files from "./Files";
import Users from "./Users";
import Accounts from "./Accounts";
import Groups from "./Groups";
import Stripe from "./Stripe";
import PostTasks from "./PostTasks";
import DraftCollections from "./DraftCollections";
import Post from "./Post";
import UserTeam from "./UserTeam";
import Packages from "./Packages";
import Transaction from "./Transaction";
import FacebookPages from "./FacebookPages";
import GeneratePost from "./GeneratePost";
import Support from "./Support";
import AICalendar from "./AICalendar";
import AiCredits from "./AiCredits";
import ApiTokens from "./ApiTokens";

const _request = {
  auth: new Auth(),
  files: new Files(),
  users: new Users(),
  accounts: new Accounts(),
  groups: new Groups(),
  stripe: new Stripe(),
  postTasks: new PostTasks(),
  draftCollections: new DraftCollections(),
  posts: new Post(),
  userTeam: new UserTeam(),
  packages: new Packages(),
  transactions: new Transaction(),
  facebookPages: new FacebookPages(),
  generatePost: new GeneratePost(),
  support: new Support(),
  aiCalendar: new AICalendar(),
  aiCredits: new AiCredits(),
  apiTokens: new ApiTokens(),
};

export default _request;
